import { Honeybadger } from "@honeybadger-io/react";
import { localStorageSizes } from "../utils/debug";

const isIgnoredError = (errorMessage) => {
  return ["Connection to Indexed Database server lost"].some((ignoredError) =>
    errorMessage.includes(ignoredError),
  );
};

function notifyHoneybadger(error, context, fingerprint = undefined) {
  return new Promise((success, reject) => {
    if (
      !Honeybadger.notify(error, {
        context: context,
        afterNotify: (error, notice) => {
          success(notice);
        },
        ...(fingerprint ? { fingerprint } : {}),
      })
    ) {
      reject();
    }
  });
}

let errors = {};
errors.report = async function (err, context = {}) {
  try {
    if (isIgnoredError(err.message) || errors.isAxiosAbort(err)) {
      return; // Don't report canceled axios requests - that generally means the user navigated to another page during a request.
    }
    if (Honeybadger.config.apiKey) {
      if (err.response) {
        context["server-output"] = err.response?.data;
      }
      if (err.request) {
        context["response-url"] = err.request?.responseURL;
        context["response-status"] = err.request?.status;
      }
      try {
        context["local-storage-sizes"] = JSON.stringify(localStorageSizes());
      } catch (err) {
        // swallow errors
      }

      const fingerprint =
        context["response-url"]?.length > 0 && context["response-status"]
          ? `${context["response-url"]} ${context["response-status"]}`
          : undefined;
      return (await notifyHoneybadger(err, context, fingerprint)).id;
    } else {
      console.log(err);
    }
  } catch (error) {
    console.error("Unable to report error to error reporting service!");
    console.log(error);
  }
};

errors.isAxiosAbort = function (err) {
  return err?.code === "ERR_CANCELED";
};

export default errors;
